import Navbar from "../components/Navbar";
import ReactMarkdown from "react-markdown";
import React, { useEffect } from "react";
import useState from "react-usestateref";
import remarkGfm from "remark-gfm";
import '../index.css';
import { Typography, Box, Divider, } from "@mui/material";

const DOC_TABS = [
  { key: "configs", label: "Configs", file: "config.md" },
  { key: "filesList", label: "Files List", file: "files_list.md" },
  { key: "queryEditor", label: "Query Editor", file: "query_editor.md" },
  { key: "createFunctions", label: "Create and List Functions", file: "create_list_functions.md" },
  { key: "applyFunctions", label: "Apply Functions", file: "apply_functions.md" },
  { key: "users", label: "Users", file: "user_management.md" },
  { key: "manageBuilds", label: "Manage Builds", file: "build_management.md" },
  { key: "userProfile", label: "User Profile Menu", file: "user_profile_menu.md" },
  
];

const HOW_TO_TABS = [
  { key: "invertibleUseCases", label: "Invertible Use Cases", file: "invertible_use_cases.md" },
  { key: "accountTypes", label: "Invertible Account Types", file: "invertible_account_types.md" },
  { key: "runOnEdge", label: "Running On Edge - Deployment", file: "run_on_edge.md" },
  { key: "runOnEdgeInternals", label: "Running On Edge - Internals", file: "run_on_edge_internals.md"},
  { key: "functionalMarketPlace", label: "Functional Market Place", file: "functional_market_place.md" },
  { key: "functionalMarketPlaceInternals", label: "Functional Market Place - Internals", file: "functions_market_place_internals.md" },
  
];

const DOC_PAGES = {
  runOnEdgeInternals: {
    imageMaxWidth: "1000px",
  },
  functionalMarketPlaceInternals:{
    imageMaxWidth: "700px",
  },
  invertibleUseCases:{
    imageMaxWidth: "1000px",
  },
  applyFunctions:{
    imageMaxWidth: "500px",
  },
  userProfile:{
    imageMaxWidth: "300px",
  }
  
};

function Documents() {
  console.log("RENDERING", new Date().toISOString());
  console.trace("RENDERING");
  const [activeTab, setActiveTab] = useState("runOnEdge");
  const [markdown, setMarkdown] = useState("");

  const loadDoc = async (file) => {
    const res = await fetch(`/docs/${file}`);
    const text = await res.text();
    setMarkdown(text);
  };
  const imageMaxWidth = DOC_PAGES[activeTab]?.imageMaxWidth || "500px";

  // load default tab
  useEffect(() => {
    //const defaultFile = DOC_TABS.find(t => t.key === activeTab)?.file;
    const defaultFile = HOW_TO_TABS.find(t => t.key === activeTab)?.file;
    loadDoc(defaultFile);
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab.key);
    loadDoc(tab.file);
  };

  return (
    <div className="main-container">

    {/* NOTE */}
  <div
    style={{
      paddingLeft: "20px",
      color: "#16a34a",
      height: "30px",
      marginBottom: "10px",
    }}
  >
    <span
      style={{
        position: "relative",
        top: "-40px",
      }}
    >
      Note: Keep checking the documentation regularly. We are continually updating.
    </span>
  </div>

  <div
    style={{
      paddingLeft: "20px",
      color: "#16a34a",
      height: "30px",
      marginBottom: "10px",
    }}
  >

  <span
      style={{
        position: "relative",
        top: "-50px",
      }}
    >
      Note: Use the Info tip in the pages of the Invertible Web App to know more about the specifc features usage.
    </span>
    </div>



      <div style={{ display: "flex", height: "100%" }}>

        {/* LEFT SIDEBAR */}
        <div
          style={{
            width: "300px",
            borderRight: "1px solid #e5e7eb",
            padding: "20px",
          }}
        >

        <Typography variant="h6">Invertible Use cases</Typography>
         <Divider sx={{ my: 2 }} />
        {HOW_TO_TABS.map((tab) => (
            <div
              key={tab.key}
              onClick={() => handleTabClick(tab)}
              style={{
                padding: "10px",
                cursor: "pointer",
                borderRadius: "6px",
                marginBottom: "6px",
                background:
                  activeTab === tab.key ? "#e0f2fe" : "transparent",
                fontWeight: activeTab === tab.key ? 600 : 400,
              }}
            >
              {tab.label}
            </div>
          ))}
          <br></br>
          <br></br>
          <br></br>
          <Typography variant="h6">UI Features</Typography>
          <Divider sx={{ my: 2 }} />
          {DOC_TABS.map((tab) => (
            <div
              key={tab.key}
              onClick={() => handleTabClick(tab)}
              style={{
                padding: "10px",
                cursor: "pointer",
                borderRadius: "6px",
                marginBottom: "6px",
                background:
                  activeTab === tab.key ? "#e0f2fe" : "transparent",
                fontWeight: activeTab === tab.key ? 600 : 400,
              }}
            >
              {tab.label}
            </div>
          ))}

        </div>

      {/* RIGHT CONTENT */}
      <div
        style={{
          flex: 1,
          padding: "20px",
          overflowY: "auto",
        }}
      >

<Box sx={{ pb: 8 }}>
  <ReactMarkdown
    remarkPlugins={[remarkGfm]}
    components={{
      img: ({ node, ...props }) => (
        <div style={{ overflowX: "auto" }}>
          <img
            src={`/docs/${props.src}`}
            alt={props.alt}
            style={{
              width: "100%",
              maxWidth: imageMaxWidth,
              height: "auto",
              borderRadius: "8px",
              margin: "16px 0",
              display: "block",
            }}
          />
        </div>
      ),
    }}
  >
    {markdown}
  </ReactMarkdown>
</Box>

        </div>

      </div>
    </div>
  );
}

export default Documents;